import { render, staticRenderFns } from "./input-editor.vue?vue&type=template&id=122ebda1&"
import script from "./input-editor.vue?vue&type=script&lang=js&"
export * from "./input-editor.vue?vue&type=script&lang=js&"
import style0 from "./input-editor.vue?vue&type=style&index=0&id=122ebda1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports